module.exports = __webpack_public_path__ + "assets/img/mobile.689e9396.jpg";